
import { StepValidation } from "../trackLeadPayload";

export const financialLeasingSteps: StepValidation = {
    bank: ["bank"],
    userInfo: ["firstName", "lastName", "email", "phone", "language", "privacyPolicy", "bank", "zip"],
    companyInfo: ["enterpriseNumber", "enterpriseName"],
    investment: ["carModel", "constructionYear", "interestRate", "netInvestmentAmount", "supplierOrderNumber"],
    desiredFinancing: ["privacyPolicyKbc"],
    viewProposals: ["journeyCompleted"],
}
